var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 78,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 59.3v2c0 4.1 3.3 7.4 7.4 7.4h58.3c4 0 7.3-3.3 7.3-7.3V28c0-4-3.3-7.3-7.3-7.3h-3.1V52c0 4-3.3 7.3-7.3 7.3H27ZM10.4 55.1H29c.3 0 .4.4.1.6L8.5 67.8A1 1 0 0 1 7 66.7L10.4 55ZM92.7 68.7l1.1 8a1 1 0 0 1-1.6 1.1L78 69.2c-.3-.2-.2-.5.1-.5h14.7Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4 0C4.7 0 0 4.7 0 10.4v34.3c0 5.8 4.7 10.4 10.4 10.4H74c5.7 0 10.4-4.6 10.4-10.4V10.4C84.4 4.7 79.7 0 74 0H10.4ZM22 33.3a5.2 5.2 0 1 0 0-10.4 5.2 5.2 0 0 0 0 10.4Zm26-5.2a5.2 5.2 0 1 1-10.4 0A5.2 5.2 0 0 1 48 28Zm15.6 5.2a5.2 5.2 0 1 0 0-10.4 5.2 5.2 0 0 0 0 10.4Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuChatIcon);
export default __webpack_public_path__ + "static/media/menu-chat-icon.e36e38b65e499b01f51091f48514ef5d.svg";
export { ForwardRef as ReactComponent };